import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReportTemplate } from '../../models/comodel/mergefieldsmodel.model';
import { Organization } from '../models/organization.model';

@Injectable()
export class ReportingService {

  static readonly ReportContextPrefix = '$.reporting.';

  static readonly ChiefOrderTemplateIds = [
    'nMgnzCsnMgoZRvwhX', 'nMgN8INnMgO4Ii2YXS', 'nMi6T6InMi8UWH0iAO', 'nLASllVnLAVYAM14Rq', 'nMlYw93nMm3jIl02lD',
    'nLRfnWKnLRhA6w0Jvh', 'nMb65wgnMbicTfsXy', 'nMb65wPnMbkjxsUcm', 'nMb65vfnMb7kpX1qKV', 'nMaRc77nMaRsl97p',
    'nMmtYDKnMmu5QWuHA', 'nMmtYEjnMmwDab2V2u', 'nMmtYESnMmDQwNTak', 'nLRfnXmnLRopmy1Zjm', 'nMmJVt5nMmKAQmEBm',
    'nM5CNHFnM5OkJ911l4', 'nM5RizknM5RoQw0BIw', 'nMmJVtGnMmOWBH2eoj', 'nMru9UwnMry6id1yjX', 'nMslSejnMsm5uy0cnn',
    'nM6bRhJnM6fGg61VyB', 'nM6bRihnM6igx057u', 'nMmYpJDnMn3Hje5v2', 'nMmJVutnMmXZEA1BwN', 'nMru9UknMrv11f0w8Q',
    'nM6bRj4nM6odmb2Xrc', 'nM5RizTnM5UpiM0TgQ', 'nM6bRgInM6bRl92kpP', 'nM6bRhenM6e80g2jsF', 'nM6sowonM6sLjy28oT',
    'nMslSetnMsqrYZ0i0x', 'nMHws0BnMHwSKu9TG', 'nMbotOhnMboPrm1Dto', 'nMbotORnMbrB4t21dl', 'nMbotPtnMbwgMl09TF',
    'nM6sowTnM6uUObJ89', 'nM6soxsnM6EhcQ2M', 'nMbotQ2nMbAse11RCn'
  ];

  public _data = new BehaviorSubject({});

  constructor() { }

  addToken(token: ReportToken): void {
    if (!this.data.tokens) this.data.tokens = [];
    this.data.tokens.push(token);
  }

  get data(): ReportData {
    return this._data.value as ReportData;
  }

  setData(message: ReportData): void {
    this._data.next(message);
  }

}

export interface ReportData {
  template?: ReportTemplate;
  org?: Organization;
  tokens?: ReportToken[];
}

export interface ReportToken {
  key: string,
  value: string
}

export enum ReportType {
  ChiefOrder,
  Letter
}
